import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMoneys = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12.8673 5.28097V8.71431C12.8673 10.7676 11.694 11.6476 9.93396 11.6476H4.07395C3.77395 11.6476 3.48729 11.621 3.22062 11.561C3.05395 11.5343 2.89396 11.4877 2.74729 11.4343C1.74729 11.061 1.14062 10.1943 1.14062 8.71431V5.28097C1.14062 3.22763 2.31395 2.34766 4.07395 2.34766H9.93396C11.4273 2.34766 12.5006 2.98099 12.7873 4.42765C12.834 4.69432 12.8673 4.96763 12.8673 5.28097Z",
			stroke: "#B6B6B6",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.8674 7.283V10.7163C14.8674 12.7697 13.694 13.6497 11.934 13.6497H6.07404C5.5807 13.6497 5.13404 13.583 4.74738 13.4364C3.95404 13.143 3.41404 12.5364 3.2207 11.563C3.48737 11.623 3.77404 11.6497 4.07404 11.6497H9.93404C11.694 11.6497 12.8674 10.7697 12.8674 8.71635V5.283C12.8674 4.96967 12.8407 4.68969 12.7874 4.42969C14.054 4.69635 14.8674 5.58967 14.8674 7.283Z",
			stroke: "#B6B6B6",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.00024 8.76221C7.97227 8.76221 8.76025 7.97422 8.76025 7.0022C8.76025 6.03018 7.97227 5.24219 7.00024 5.24219C6.02822 5.24219 5.24023 6.03018 5.24023 7.0022C5.24023 7.97422 6.02822 8.76221 7.00024 8.76221Z",
			stroke: "#B6B6B6",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.1875 5.53516V8.46851",
			stroke: "#B6B6B6",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.8145 5.53516V8.46851",
			stroke: "#B6B6B6",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgMoneys;
